import { facetGroupCode } from 'shared/config/common';
import { IFacetGroup } from 'shared/models/facet';

import { ICommonTranslation } from 'models/translation';

import defaultsWithFallback from 'helpers/defaultsWithFallback';
import { fallbackTranslation } from 'services/api/fallbackData';

import { IReportConcernPopupTexts } from './ReportConcernPopup';

const fallbackCommonTranslation = fallbackTranslation.common;

export function prepareReportConcernPopupTexts(
  commonTranslation: ICommonTranslation,
  complaintCategories: IFacetGroup[]
): IReportConcernPopupTexts {
  const commonTexts = defaultsWithFallback(
    commonTranslation?.reportConcernPopup,
    fallbackCommonTranslation.reportConcernPopup
  );
  const commonValidationTexts = defaultsWithFallback(
    commonTranslation?.validationMessages,
    fallbackTranslation.common.validationMessages
  );
  const typeOptions =
    complaintCategories
      .find((group) => group.code === facetGroupCode.complaintCategory.other)
      ?.facets.map((facet) => ({ value: facet.id, name: facet.name })) ?? [];

  return {
    title: commonTexts.reportConcernTitle,
    detailsLabel: commonTexts.reportConcernDetailsLabel,
    detailsPlaceholder: commonTexts.reportConcernDetailsPlaceholder,
    typeDropdownLabel: commonTexts.reportConcernTypeDropdownLabel,
    typeDropdownPlaceholder: commonTexts.reportConcernTypeDropdownPlaceholder,
    typeOptions,
    sendButton: commonTexts.reportConcernSendButton,
    sendButtonLoading: commonTexts.reportConcernSendButtonLoading,
    cancelButton: commonTexts.reportConcernCancelButton,
    errors: {
      fields: {
        typeId: { required: commonValidationTexts.validationMessagesRequired },
        details: { required: commonValidationTexts.validationMessagesRequired },
      },
    },
  };
}
